export default{
    url: "http://175.24.249.4/files/happy_binary_resource/official_management_system/resource_static",
    urls: "http://123.206.54.57:6001",
    api: "http://123.206.54.57:6002",
    web: "http://123.206.54.57:6003",
}
